/**
 * Check-Liste für Filter-Dropdowns.
 *
 * Aus `InserateFilterBar` herausgezogen, damit die Tourismus-Filterleiste
 * dieselben Bausteine nutzt, ohne die Sachbearbeiter-Leiste zu übernehmen.
 * Verhalten unverändert; `counts` ist neu und optional.
 */
export default function CheckboxList({
  options,
  selected,
  onToggle,
  emptyText,
  counts,
}: {
  options: string[];
  selected: string[];
  onToggle: (value: string) => void;
  emptyText?: string;
  /** Optionale Trefferzahl je Option, rechtsbündig in Grau. */
  counts?: Record<string, number>;
}) {
  if (options.length === 0)
    return (
      <p className="text-xs text-gray-400 px-1 py-2 text-center">
        {emptyText ?? 'Keine Optionen'}
      </p>
    );

  return (
    <div className="space-y-0.5">
      {options.map(opt => (
        <label
          key={opt}
          className="flex items-center gap-2.5 py-1.5 px-1 cursor-pointer hover:bg-gray-50 rounded-lg"
        >
          <input
            type="checkbox"
            checked={selected.includes(opt)}
            onChange={() => onToggle(opt)}
            className="rounded border-gray-300 text-gray-900"
          />
          <span className="text-sm flex-1 truncate">{opt}</span>
          {counts?.[opt] !== undefined && (
            <span className="text-xs text-gray-400 tabular-nums">{counts[opt]}</span>
          )}
        </label>
      ))}
    </div>
  );
}
